import { UseFormReturn } from "@endya-conformite/ui-kit/src/lya/react-hook-form";
import REFASSU from "@src/assets/data/REFASSU.json";
import { AutoCompleteWithList } from "@src/components/AutocompleteWithList/AutocompleteWithList";
import Fuse from "fuse.js";

export type FournisseurData = {
  fournisseur: string;
  fournisseurs: { value: string }[];
};

type FournisseurRefassuProps = {
  form: UseFormReturn<FournisseurData>;
};
const fuse = new Fuse(REFASSU, { threshold: 0.4 });
export function FournisseurRefassu({ form }: FournisseurRefassuProps) {
  const value = form.watch("fournisseur");
  return (
    <AutoCompleteWithList<"fournisseur", "fournisseurs">
      form={form}
      label="Sélectionnez les fournisseurs à ajouter"
      placeholder="Saisir le(s) fournisseur(s)"
      options={(value
        ? fuse.search(value, { limit: 20 }).map((r) => r.item)
        : REFASSU.slice(0, 20)
      ).map((item) => ({
        label: item,
        value: item,
      }))}
      nameSelected="fournisseurs"
      nameSearch="fournisseur"
    />
  );
}
